import script from "./ArchivesWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchivesWidget.vue?vue&type=script&setup=true&lang=js"

import "./ArchivesWidget.vue?vue&type=style&index=0&id=5e0eefcc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e0eefcc"]])

export default __exports__